import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dateUtils from '@/utils/dateUtil';
import SlotCounterStationSoldDistributionSheet from '@/components/Counter/SlotCounterStationSoldDistributionSheet';
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
  name: 'StationSaleDistribution',
  components: {
    SlotCounterStationSoldDistributionSheet: SlotCounterStationSoldDistributionSheet
  },
  data: function data() {
    return {
      datePickerValue: [(dateUtils.todayTimestamp() - 86400) * 1000, (dateUtils.todayTimestamp() - 86400) * 1000],
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return pTime.getTime() < new Date() - 91 * 86400 * 1000 || pTime.getTime() > new Date() - 86400 * 1000;
        }
      }
    };
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({}, mapGetters('stations', ['asyncStations'])), mapGetters('user', ['userInfo'])),
  methods: {
    monthStart: function monthStart(ts) {
      return moment(new Date(ts)).startOf('month').unix() * 1000;
    },
    monthEnd: function monthEnd(ts) {
      return moment(new Date(ts)).endOf('month').unix() * 1000;
    }
  }
};